/**
 * Screen related helper functions.
 */
const MXM = 100

export const ScreenUtils = {

    /**
     * calculate the current percentage of the page that is viewed
     *
     * @return % of page viewed
     */
    currentPageViewPercentage(): number {
        const percentage = Math.round(
            (window.innerHeight + window.pageYOffset) / (document.body.scrollHeight) * MXM)
        // document.body.scrollHeight could be 0:
        // https://stackoverflow.com/questions/51690101/
        // why-execute-scriptreturn-document-body-scrollheight-with-python-selenium-ret
        if (Number.isFinite(percentage)) {
            if (percentage > MXM) {
                return MXM
            }
            return percentage
        }
        return 0
    },

    /**
     * calculate the current percentage of the page up to given element that is viewed
     *
     * @return % of page viewed up to given element
     */
    currentElementViewPercentage(el: Element): number {
        const percentage = Math.round(
            (window.innerHeight + window.pageYOffset) / (el.getBoundingClientRect().top + window.pageYOffset) * MXM)
        if (Number.isFinite(percentage)) {
            if (percentage > MXM) {
                return MXM
            }
            return percentage
        }
        return 0
    }
}
